import { CSSProperties, ReactNode, useEffect, useState } from 'react';
import useCadastrarPageHook, {
  FormCadastrarUsuario,
} from '@/components/pages/Cadastrar/hook/useCadastrarPageHook';
import EtapaDadosPessoais from '@/components/organisms/FormUsuario/components/organisms/EtapaDadosPessoais';
import Button from '@/components/atoms/Button';
import EtapaContato from '@/components/organisms/FormUsuario/components/organisms/EtapaContato';
import { theme } from '@/styles/theme';
import EtapaSenhaETermos from '@/components/organisms/FormUsuario/components/organisms/EtapaSenhaETermos';
import { Root } from '@radix-ui/react-form';
import * as S from './styles';

export enum EtapaCadastroEnum {
  etapaDadosPessoais = 1,
  etapaContato = 2,
  etapaSenhaETermos = 3,
}

export const camposSeraoValidadosPorStep: Record<
  EtapaCadastroEnum,
  Array<keyof FormCadastrarUsuario>
> = {
  [EtapaCadastroEnum.etapaDadosPessoais]: [
    'nome',
    'cpf',
    'dataNascimento',
    'tipoGeneroID',
  ],
  [EtapaCadastroEnum.etapaContato]: ['email', 'telefone'],
  [EtapaCadastroEnum.etapaSenhaETermos]: ['senha', 'confirmacaoSenha'],
};

export const camposObrigatoriosQueSeraoValidadosPorStep: Record<
  EtapaCadastroEnum,
  Array<keyof FormCadastrarUsuario>
> = {
  1: ['nome', 'dataNascimento', 'tipoGeneroID'],
  2: ['email', 'telefone'],
  3: ['senha', 'confirmacaoSenha'],
};

interface CadastradoUsuarioEtapasProps {
  etapaCadastro: EtapaCadastroEnum;
  onSubmit: (form: FormCadastrarUsuario) => Promise<void>;
  funcaoBotaoForm: () => void;
  styleForm?: CSSProperties;
  BotoesAdicionais?: ReactNode;
  cpfObrigatorio?: boolean;
}

export default function CadastradoUsuarioEtapas(
  props: CadastradoUsuarioEtapasProps,
) {
  const {
    etapaCadastro,
    onSubmit,
    funcaoBotaoForm,
    styleForm = {},
    BotoesAdicionais = null,
    cpfObrigatorio = false,
  } = props;

  const {
    // cadastrandoUsuario,
    control,
    register,
    errors,
    // isValid,
    setPaisSelecionado,
    paisSelecionado,
    opcoesIdentidadeGenero,
    setIdentidadeGeneroSelecionada,
    aceitarTermos,
    usuarioAceitouOsTermos,
    watch,
    getValues,
    handleSubmit,
    cadastrandoUsuario,
  } = useCadastrarPageHook({
    cpfObrigatorio,
  });

  const [formEstaValido, setFormEstaValido] = useState(false);

  const campos = camposSeraoValidadosPorStep[etapaCadastro];
  const valoresStep = watch(campos);

  useEffect(() => {
    const campos = camposSeraoValidadosPorStep[etapaCadastro];
    const obrigatorios =
      camposObrigatoriosQueSeraoValidadosPorStep[etapaCadastro];
    const valores = getValues();

    const valido = campos.every((campo) => {
      const valor = valores[campo];
      const temErro = campo in errors;

      const preenchido = !(
        valor === null ||
        valor === undefined ||
        (typeof valor === 'string' && valor.trim() === '')
      );

      if (obrigatorios.includes(campo) || (campo === 'cpf' && cpfObrigatorio)) {
        if (etapaCadastro === EtapaCadastroEnum.etapaSenhaETermos)
          return usuarioAceitouOsTermos && preenchido && !temErro;
        return preenchido && !temErro;
      } else {
        if (etapaCadastro === EtapaCadastroEnum.etapaSenhaETermos)
          return usuarioAceitouOsTermos && !temErro;
        return !temErro;
      }
    });

    setFormEstaValido(valido);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valoresStep, errors, etapaCadastro, usuarioAceitouOsTermos]);

  return (
    <Root
      id="form_cadastrar_usuario_modal"
      onSubmit={handleSubmit(onSubmit)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        ...(etapaCadastro === EtapaCadastroEnum.etapaSenhaETermos
          ? {
              gap: theme.spacing[4],
            }
          : {}),
        ...styleForm,
      }}
    >
      {etapaCadastro === EtapaCadastroEnum.etapaDadosPessoais ? (
        <EtapaDadosPessoais
          $control={control}
          $errors={errors}
          $register={register}
          $selecionarIdentidadeGenero={setIdentidadeGeneroSelecionada}
          $opcoesIdentidadeGenero={opcoesIdentidadeGenero}
          inputSize={1}
          styleConteudoDropdown={{
            maxHeight: 90,
          }}
          cpfObrigatorio={cpfObrigatorio}
        />
      ) : null}
      {etapaCadastro === EtapaCadastroEnum.etapaContato ? (
        <EtapaContato
          $control={control}
          $errors={errors}
          $register={register}
          $paisSelecionado={paisSelecionado}
          $selecionarPais={setPaisSelecionado}
          inputSize={1}
          styleConteudoDropdown={{
            maxHeight: 90,
          }}
        />
      ) : null}
      {etapaCadastro === EtapaCadastroEnum.etapaSenhaETermos ? (
        <EtapaSenhaETermos
          $control={control}
          $errors={errors}
          $register={register}
          aceitarTermos={aceitarTermos}
          usuarioAceitouOsTermos={usuarioAceitouOsTermos}
          inputSize={1}
          watchValue={watch}
          style={{
            gap: theme.spacing[2],
          }}
        />
      ) : null}
      <S.ContainerBotoesFooter
        style={{
          ...(etapaCadastro === EtapaCadastroEnum.etapaSenhaETermos
            ? { marginTop: theme.spacing[3] }
            : {}),
        }}
      >
        {BotoesAdicionais}
        <Button
          $size={2}
          $type="button"
          $variant="solid"
          $focusRing
          $highContrast={true}
          $color="neutral"
          $disable={!formEstaValido}
          $loading={cadastrandoUsuario}
          $text={'Próximo'}
          style={{
            justifyContent: 'center',
            color: formEstaValido ? theme.colors.default.black : undefined,
            flex: 1,
          }}
          $onClick={funcaoBotaoForm}
        />
      </S.ContainerBotoesFooter>
    </Root>
  );
}
